import React from "react";
import "./HowWorks.css";
import { Col, Row } from "antd";
import { PiNotePencilDuotone } from "react-icons/pi";
import { MdOutlineKeyboardHide } from "react-icons/md";
import { FaChartLine } from "react-icons/fa";

const HowWorks = () => {
  return (
    <>


      <Row
        className="md:px-12 md:py-[25px] xl:px-12 xl:pt-[25px] bg-[#FFF8EC]"
        justify="end"
      >
        <Col
          xs={24}
          sm={24}
          md={20}
          lg={13}
          xl={10}
          xxl={8}
          className="flex flex-col items-start xs:p-2 xxs:p-2 justify-end md:w-full text-left"
        >
          <div className="flex flex-col items-end  md:w-full text-left">
            {/* Section Title */}
            <div className="flex items-center w-full justify-end sm:mb-5 mb-3">
              <p className="text-black text-normal sm:text-sm md:text-[18px] lg:text-[18px] font-normal">
                NET4SURGE : TRANSFORMING SUCCESS
              </p>
              <hr className="border-t-2 border-black ml-2 hidden sm:block flex-grow max-w-[150px]" />
            </div>

            {/* Main Heading */}
            <div className="flex items-center w-full justify-end sm:mb-5 mb-3">
              <p className="text-right text-xl xs:text-3xl pt-3 md:text-[25px] lg:text-[25px]">
                How Net4Surge Works for Your Business
              </p>
            </div>
          </div>
        </Col>
      </Row>


      <div className="bg-[#FFF8EC]">
        <Row
          justify={"space-around"}
          className="text-center xs:p-5 xxs:p-5 md:pt-8 md:ps-8 md:px-8 xl:pt-12 xl:ps-12 xl:px-12 sm:pt-8 sm:ps-8 sm:px-8"
        >
          <Col
         className=" pt-[70px] xs:pl-[25px] xs:pr-[35px] relative bg-[#F9B138] shadow-lg flex flex-col justify-between items-center rounded-lg mb-6 xl:h-[16rem] mt-4"
         xs={22}
       sm={22}
       md={7}
       lg={7}
       xl={7}
       xxl={7}
       style={{ padding: "70px 2px", position: "relative" }}
          >
            {/* Icon placed slightly below the top */}
            <div className="absolute -top-10 sm:top-[-50px] rounded-full bg-[#FDF0CE]  p-3">
              <PiNotePencilDuotone
                size={60}
                className="text-[#FBCA25] rounded-full"
              />
            </div>

            {/* Text Section */}
            <p
              className="text-black tracking-wider text-lg sm:text-base md:text-2xl text-center mb-2"
              style={{ fontFamily: '"Roboto", sans-serif' }}
            >
              Add Listings
            </p>
            <p
              className="text-black text-center text-xs sm:text-sm md:text-lg p-2"
              style={{ fontFamily: '"Roboto", sans-serif' }}
            >
              Easily add your business details with our simple and intuitive
              listing process.
            </p>
          </Col>

          <Col
              className=" pt-[70px] xs:pl-[25px] xs:pr-[35px] relative bg-[#F9B138] shadow-lg flex flex-col justify-between items-center rounded-lg mb-6 xl:h-[16rem] mt-4"
              xs={22}
            sm={22}
            md={7}
            lg={7}
            xl={7}
            xxl={7}
            style={{ padding: "70px 2px", position: "relative" }}
          >
            {/* Icon placed slightly below the top */}
            <div className="absolute -top-10 sm:top-[-50px] rounded-full bg-[#FDF0CE] p-3">
              <MdOutlineKeyboardHide
                size={60}
                className="text-[#FBCA25] rounded-full"
              />
            </div>

            {/* Text Section */}
            <p
              className="text-black tracking-wider text-lg sm:text-base md:text-2xl text-center mb-2"
              style={{ fontFamily: '"Roboto", sans-serif' }}
            >
              Publish Listings
            </p>
            <p
              className="text-black text-center text-xs sm:text-sm md:text-lg mt-2 p-2"
              style={{ fontFamily: '"Roboto", sans-serif' }}
            >
              Publish your listings instantly to make your business visible to
              millions of potential customers.
            </p>
          </Col>

          <Col
             className=" pt-[70px] xs:pl-[25px] xs:pr-[35px] relative bg-[#F9B138] shadow-lg flex flex-col justify-between items-center rounded-lg mb-6 xl:h-[16rem] mt-4"
             xs={22}
           sm={22}
           md={7}
           lg={7}
           xl={7}
           xxl={7}
           style={{ padding: "70px 2px", position: "relative" }}
          >
            {/* Icon placed slightly below the top */}
            <div className="absolute -top-10 sm:top-[-50px] rounded-full bg-[#FDF0CE] p-3">
              <FaChartLine size={60} className="text-[#FBCA25] rounded-full" />
            </div>

            {/* Text Section */}
            <p
              className="text-black tracking-wider text-lg sm:text-base md:text-2xl text-center"
              style={{ fontFamily: '"Roboto", sans-serif' }}
            >
              Get Exposure
            </p>
            <p
              className="text-black text-center text-xs sm:text-sm md:text-lg mt-2 p-2"
              style={{ fontFamily: '"Roboto", sans-serif' }}
            >
              Gain significant exposure and connect with a broader audience
              across the globe.
            </p>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HowWorks;
